import React, {  useEffect, useState,useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"; 
import Box from '@mui/material/Box'; 
import Container from '@mui/material/Container';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField'; 
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import { warningErrorAction } from "actions/ErrorActions";
import "css/generalSettings.css";
import "css/customDialog.css";
import PropTypes from 'prop-types'; 

const initialArticlesize = [
  {
    "id" : 0,
    "indexrowypesofsizes":0,
    "enabletypesofsizearticle":true,
    "typeofsize_id" : 0,
    "typeofsize_namees" : "",
    "typeofsize_nameen" : "",
    "typeofsize_symbolsizes": "",
  }
];

const ArticleCreateOrEditTypesOfSize = ({
  openEditRowTypesOfSize,
  setOpenEditRowTypesOfSize,
  openEditNewTypesOfSize,
  setOpenEditNewTypesOfSize,
  formArticle,
  setFormArticle,
  editRowTypesOfSize,
  setEditRowTypesOfSize, 
  typesOfSizeToSelect}) => {
  const {t,i18n} = useTranslation(['listDataArticles']); 
  const token = useSelector((state) => state.loginUser.token); 
  const [newTypesOfSize,setNewTypesOfSize]= useState(initialArticlesize);
  const [errorsTypesOfSize, setErrorsTypesOfSize] = useState({});
  const dispatch = useDispatch();

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && openEditRowTypesOfSize) {
        setNewTypesOfSize(newTypesOfSize => ({
           ...newTypesOfSize,
          id:0,
          indexrowypesofsizes:0,
          enabletypesofsizearticle: true,
          typeofsize_id:0,
          typeofsize_namees:"",
          typeofsize_nameen:"",
          typeofsize_symbolsizes:""
        }));
        setEditRowTypesOfSize(initialArticlesize);
        setErrorsTypesOfSize({}); 
        setOpenEditRowTypesOfSize(false);
        setOpenEditNewTypesOfSize(false);

      }
    },[
      setNewTypesOfSize,
      setErrorsTypesOfSize, 
      setEditRowTypesOfSize,
      setOpenEditRowTypesOfSize,
      openEditRowTypesOfSize,
      setOpenEditNewTypesOfSize,
      ]
  );

  const handleCloseNewTypesOfSize = () => {
    setOpenEditNewTypesOfSize(false);
    setNewTypesOfSize(newTypesOfSize => ({
      ...newTypesOfSize,
      id:0,
      indexrowypesofsizes:0,
      enabletypesofsizearticle: true,
      typeofsize_id:0,
      typeofsize_namees:"",
      typeofsize_nameen:"",
      typeofsize_symbolsizes:""
    }));
    setEditRowTypesOfSize(initialArticlesize);
    setErrorsTypesOfSize({});
    setOpenEditRowTypesOfSize(false);
  };
  
  const handleChangeSelectTypesOfSize = (event) => {
    setNewTypesOfSize(newTypesOfSize => ({
      ...newTypesOfSize,
      typeofsize_id:event.target.value
    }));
  };

  const handleBlurSelectTypesOfSize= (e) => {
    handleChangeSelectTypesOfSize(e);
    setErrorsTypesOfSize(validateFormTypesOfSize());
  };

   const handleChangeEnabledTypesOfSize = () => {
    setNewTypesOfSize(newTypesOfSize => ({
      ...newTypesOfSize,
      enabletypesofsizearticle: !newTypesOfSize.enabletypesofsizearticle
    }));
  };

  const toggleDrawerNewTypesOfSize  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseNewTypesOfSize();
    }
  }

  const validateFormTypesOfSize = () => { 
    let errorsTypesOfSize = {};
    if (newTypesOfSize.typeofsize_id==="" || newTypesOfSize.typeofsize_id===0 || newTypesOfSize.typeofsize_id===null){
      errorsTypesOfSize.typeofsize_id = 'Text_TypesOfSizeRequired';
    }

    if (!openEditNewTypesOfSize){
      if (formArticle.articlesizes.find(item => {return (Number(item.typeofsize_id)=== Number(newTypesOfSize.typeofsize_id)) })){
        errorsTypesOfSize.typeofsize_id = 'Text_TypeOfSize_Exist';
      }
    }else{
      if (formArticle.articlesizes.find((item, index) => {return(item.indexrowypesofsizes!==newTypesOfSize.indexrowypesofsizes && Number(item.typeofsize_id)=== Number(newTypesOfSize.typeofsize_id)) })){
        errorsTypesOfSize.typeofsize_id = 'Text_TypeOfSize_Exist';
      }
    }  

    return errorsTypesOfSize;
  };

  const handleSubmitNewTypesOfSize = () => {  
      setErrorsTypesOfSize(validateFormTypesOfSize());
      let errorsCheckTypesOfSize=validateFormTypesOfSize();
      if ((Object.keys(errorsCheckTypesOfSize).length === 0) 
            && newTypesOfSize.typeofsize_id!==''  
            && newTypesOfSize.typeofsize_id!==0 
            && newTypesOfSize.typeofsize_id!==null ) {
        let typesOfSizeFound = typesOfSizeToSelect.find( item => item.id === Number(newTypesOfSize.typeofsize_id));
        if (typesOfSizeFound!==undefined ) {
            let typesOfSizeToAdd={
              "id":newTypesOfSize.id!==null?newTypesOfSize.id:"",
              "indexrowypesofsizes" : openEditNewTypesOfSize?newTypesOfSize.indexrowypesofsizes:formArticle.articlesizes.length>0?formArticle.articlesizes[formArticle.articlesizes.length-1].indexrowypesofsizes+1:1,
              "enabletypesofsizearticle":newTypesOfSize.enabletypesofsizearticle,
              "typeofsize_id":typesOfSizeFound.id,
              "typeofsize_namees":typesOfSizeFound.namees,
              "typeofsize_nameen":typesOfSizeFound.nameen,
              "typeofsize_symbolsizes":typesOfSizeFound.symbolsizes
          }
          if (!openEditNewTypesOfSize){
            formArticle.articlesizes.push(typesOfSizeToAdd);
          }else{
            let idx=formArticle.articlesizes.findIndex(((item) => item.indexrowypesofsizes === newTypesOfSize.indexrowypesofsizes));
            formArticle.articlesizes[idx]=typesOfSizeToAdd
          }
          setFormArticle(formArticle => ({
            ...formArticle,
          }))
        }
        handleCloseNewTypesOfSize();
      }else{
        if (errorsCheckTypesOfSize.typeofsize_id){
          dispatch(warningErrorAction(t(errorsCheckTypesOfSize.typeofsize_id)));
        }else{
          dispatch(warningErrorAction(t('Text_Error_Save_Data')));
        }
  
      }  
    };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

 useEffect(() => {
     if (openEditNewTypesOfSize ){
       setNewTypesOfSize(newTypesOfSize => ({
         ...newTypesOfSize,
         id:editRowTypesOfSize.id!==null?editRowTypesOfSize.id:"",
         indexrowypesofsizes:editRowTypesOfSize.indexrowypesofsizes!==null?editRowTypesOfSize.indexrowypesofsizes:1,
         enabletypesofsizearticle:editRowTypesOfSize.enabletypesofsizearticle!==null?editRowTypesOfSize.enabletypesofsizearticle:true,
         typeofsize_id:editRowTypesOfSize.typeofsize_id!==null?editRowTypesOfSize.typeofsize_id:0,
         typeofsize_namees:editRowTypesOfSize.typeofsize_namees!==null?editRowTypesOfSize.typeofsize_namees:"",
         typeofsize_nameen:editRowTypesOfSize.typeofsize_nameen!==null?editRowTypesOfSize.typeofsize_nameen:"",
         typeofsize_symbolsizes:editRowTypesOfSize.typeofsize_symbolsizes!==null?editRowTypesOfSize.typeofsize_symbolsizes:""
      }));
     }else{
       setNewTypesOfSize(newTypesOfSize => ({
         ...newTypesOfSize,
         id:0,
         indexrowypesofsizes:0,
         enabletypesofsizearticle: true,
         typeofsize_id:0,
         typeofsize_namees:"",
         typeofsize_nameen:"",
         typeofsize_symbolsizes:""
       })); 
     }
   },[t,token,dispatch,i18n,editRowTypesOfSize,openEditNewTypesOfSize]);
   
  return(
    <>
      {openEditRowTypesOfSize && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerNewTypesOfSize(false)}
            onOpen={toggleDrawerNewTypesOfSize(true)}>
            <Container >
              <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '500px' }}>
                <br/>
                <div id="myDIV">
                  <h1 className="h1NewStyle px-4 mb-2">{openEditNewTypesOfSize?t('Text_TypesOfSize_Article_Edit'):t('Text_TypesOfSize_Article_New')}</h1>
                </div>  
                <hr className="sidebar-divider d-none d-md-block"/>
                <form className="createGroupSection" onSubmit={handleCloseNewTypesOfSize}>  
                  <div className="form-floating mb-3 px-4 primary">
                    <div className="form-group">
                      <label className="text-primary">{t('Text_EnableTypesOfSizeArticle')} :</label>
                      <Checkbox  
                        style={{color:"#4e73df"}} 
                        checked={newTypesOfSize.enabletypesofsizearticle} 
                        onChange={handleChangeEnabledTypesOfSize} 
                      />
                    </div>

                    <div className="form-group">  
                      <label className="text-primary">{t('Text_Select_TypesOfSizes_Article_Edit')} :</label>
                      <TextField
                        id="typeofsize_id"
                        name="typeofsize_id"
                        value={ (newTypesOfSize.typeofsize_id === undefined || newTypesOfSize.typeofsize_id ===null || newTypesOfSize.typeofsize_id ===""
                              || newTypesOfSize.typeofsize_id ==="0" || newTypesOfSize.typeofsize_id ===0)?0:newTypesOfSize.typeofsize_id}
                        inputProps={{ style: {width: 400}, maxLength: 100, }}
                        variant="outlined"
                        onBlur={handleBlurSelectTypesOfSize}
                        onChange={handleChangeSelectTypesOfSize}
                        helperText={errorsTypesOfSize.typeofsize_id!=null?t(errorsTypesOfSize.typeofsize_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (newTypesOfSize.typeofsize_id === undefined || newTypesOfSize.typeofsize_id ===null || newTypesOfSize.typeofsize_id ===""
                            || newTypesOfSize.typeofsize_id ==="0" || newTypesOfSize.typeofsize_id ===0)?0: newTypesOfSize.typeofsize_id
                        }}>
                        <option key={0} value=""/>
                        {!openEditNewTypesOfSize? 
                          typesOfSizeToSelect.map((option) => (!formArticle.articlesizes.find((item) => {return(Number(item.typeofsize_id)=== Number(option.id))})) &&
                            <option key={option.id} value={option.id}>
                              {(i18n.language==="es"?option.namees:option.nameen)}
                            </option>
                          ):
                          typesOfSizeToSelect.map((option) => (!formArticle.articlesizes.find((item) => {return(Number(item.indexrowypesofsizes!==newTypesOfSize.indexrowypesofsizes && item.typeofsize_id)=== Number(option.id))})) &&
                            <option key={option.id} value={option.id}>
                              {(i18n.language==="es"?option.namees:option.nameen)}
                            </option>
                          )
                        } 
                      </TextField>
                    </div>
                    <hr className="sidebar-divider d-none d-md-block" />
                    <div className="formdi-pending-action-group">
                      <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitNewTypesOfSize}>
                        {openEditNewTypesOfSize?t('Button_Update'):t('Button_Create')}
                      </button> 
                      <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleCloseNewTypesOfSize}>
                        {t('Button_Cancel')}
                      </button>
                    </div>
                  </div>
                </form>
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

ArticleCreateOrEditTypesOfSize.propTypes = {

  openEditRowTypesOfSize: PropTypes.bool.isRequired,
  setOpenEditRowTypesOfSize: PropTypes.func.isRequired,
  openEditNewTypesOfSize: PropTypes.bool.isRequired,
  setOpenEditNewTypesOfSize: PropTypes.func.isRequired,
  formArticle: PropTypes.object.isRequired,
  setFormArticle: PropTypes.func.isRequired, 
  setEditRowTypesOfSize: PropTypes.func.isRequired
};

export default ArticleCreateOrEditTypesOfSize;